import ContactType from "enums/ContactType";

interface NameParts {
  firstName?: string | null;
  lastName?: string | null;
}

/**
 * Joins a person's name for display, initials and accessible labels.
 *
 * `lastName` is nullable in the schema (User.graphql, Comment.graphql) even
 * though most client-side types declare it as `string`, so composing a name
 * with a template string renders the literal "null" into whatever reads it.
 * `.trim()` does not help: the gap is in the middle.
 */
export const fullName = (user?: NameParts | null): string =>
  [user?.firstName, user?.lastName].filter(Boolean).join(" ");

/**
 * "Lovelace, Ada", the surname-first form the people tables list and sort by.
 * A missing part drops out with its comma, so no surname reads "Ada".
 */
export const surnameFirstName = (user?: NameParts | null): string =>
  [user?.lastName, user?.firstName].filter(Boolean).join(", ");

interface ContactParts extends NameParts {
  businessName?: string | null;
  email?: string | null;
  contactType?: string | null;
}

export const contactName = (contact?: ContactParts | null): string => {
  const person = fullName(contact);
  const business = contact?.businessName || "";
  const preferred =
    contact?.contactType === ContactType.Business
      ? business || person
      : person || business;

  return preferred || contact?.email || "";
};

export default fullName;
